import React from 'react';

const Svg404Page = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 500 500" width="400" height="400">
    <defs>
      <clipPath id="freepik--clip-path--inject-21">
      <path
        d="M86.28,404.22v22.52A4.84,4.84,0,0,0,88.9,431l36.2,18.69a4.81,4.81,0,0,0,4.19.12l53.33-20.33a4.84,4.84,0,0,0,2.86-4.41V397.85l-61,18.43Z"
        style={{
        fill: '#ECEFF1',
        stroke: '#263238',
        strokeLinecap: 'round',
        strokeLinejoin: 'round',
        strokeWidth: '1.1930027515339008px',
        }}
      />
      </clipPath>
      <clipPath id="freepik--clip-path-2--inject-21">
      <path
        d="M142,366.2,83.5,385a2.26,2.26,0,0,0-1.57,2.16v16.68a2.27,2.27,0,0,0,1.29,2L124,425.25a2.27,2.27,0,0,0,1.77.08L187,402.42a2.27,2.27,0,0,0,1.48-2.12l.11-15.65a2.29,2.29,0,0,0-1.79-2.22l-43.64-16.29A2.36,2.36,0,0,0,142,366.2Z"
        style={{
        fill: '#fff',
        stroke: '#263238',
        strokeLinecap: 'round',
        strokeLinejoin: 'round',
        strokeWidth: '1.1930027515339008px',
        }}
      />
      </clipPath>
      <clipPath id="freepik--clip-path-3--inject-21">
      <path
        d="M97.34,290.27S95,304,96.67,310.72a28.62,28.62,0,0,0,4.69,10.39s-8.38,12.4-6.7,22.78,6,11.73,6,11.73-3.68,19.11,3,25.81,21.45,14.07,37.87,11.06,27.48-3.69,30.83-9.39,1.34-30.83,1.34-30.83-.67-27.81-1.34-44.91-3-30.83-11.06-37.53-43.57,3.69-54.29,10.72S97.34,290.27,97.34,290.27Z"
        style={{
        fill: '#ECEFF1',
        stroke: '#263238',
        strokeLinecap: 'round',
        strokeLinejoin: 'round',
        strokeWidth: '1.1930027515339008px',
        }}
      />
      </clipPath>
      <clipPath id="freepik--clip-path-4--inject-21">
      <path
        d="M167.38,273.85s-6.36-9.72-15.08-15.08-31.16-9.38-40.21-11.06-18.77-1-21.45,9-2.35,26.81.33,34.18,13.74,11.73,22.46,6.71,32.84-24.47,41.22-25.47S166.71,277.54,167.38,273.85Z"
        style={{
        fill: '#757575',
        stroke: '#263238',
        strokeLinecap: 'round',
        strokeLinejoin: 'round',
        strokeWidth: '1.1930027515339008px',
        }}
      />
      </clipPath>
      <clipPath id="freepik--clip-path-5--inject-21">
      <path
        d="M153.31,273.85c7.37-2.68,16.76-1,20.11,8.38s6.36,36.86,6.36,36.86,8.38,1,11.73,4.7,5,13.07,4.36,17.76-12.4,13.4-25.8,13.74-23.13-6-27.82-23.13S139.42,289,139.42,289s1.7-7.67,4.26-9.38"
        style={{
        fill: '#ECEFF1',
        stroke: '#263238',
        strokeLinecap: 'round',
        strokeLinejoin: 'round',
        strokeWidth: '1.1930027515339008px',
        }}
      />
      </clipPath>
    </defs>
    <g id="freepik--background-simple--inject-21">
      <path
      d="M44.31,258.15s2.35,73,63.27,121.6,145.32,52.12,213.65,56.74S442,402.43,450,344s-44.3-75.63-72.63-142.2-25.81-88.44-85.75-129.38S137.86,56.57,88.7,126.71,44.31,258.15,44.31,258.15Z"
      style={{ fill: '#ECEFF1' }}
      />
      <path
      d="M44.31,258.15s2.35,73,63.27,121.6,145.32,52.12,213.65,56.74S442,402.43,450,344s-44.3-75.63-72.63-142.2-25.81-88.44-85.75-129.38S137.86,56.57,88.7,126.71,44.31,258.15,44.31,258.15Z"
      style={{ fill: '#fff', opacity: 0.7 }}
      />
    </g>
    <g id="freepik--Hole--inject-21">
      <ellipse
      cx="341.49"
      cy="385.79"
      rx="72.2"
      ry="21.42"
      style={{
        fill: '#263238',
        stroke: '#263238',
        strokeLinecap: 'round',
        strokeLinejoin: 'round',
        strokeWidth: '1.1930027515339008px',
      }}
      />
      <path
      d="M341.49,374.22c34.15,0,62.75,7,70.26,16.49a8,8,0,0,0,1.94-4.92c0-11.84-32.33-21.43-72.2-21.43s-72.21,9.59-72.21,21.43a8,8,0,0,0,1.94,4.92C278.73,381.26,307.33,374.22,341.49,374.22Z"
      style={{
        fill: '#fff',
        stroke: '#263238',
        strokeLinecap: 'round',
        strokeLinejoin: 'round',
        strokeWidth: '1.1930027515339008px',
      }}
      />
      <path
      d="M331.63,404.52c-24.12-1.09-42.32-6-42.32-12a3.33,3.33,0,0,1,.59-1.83"
      style={{
        fill: 'none',
        stroke: '#fff',
        strokeLinecap: 'round',
        strokeLinejoin: 'round',
        strokeWidth: '1.1930027515339008px',
      }}
      />
      <path
      d="M387.6,386.68c4.13,1.75,6.49,3.75,6.49,5.88,0,6.73-23.46,12.18-52.39,12.18h-1.25"
      style={{
        fill: 'none',
        stroke: '#fff',
        strokeLinecap: 'round',
        strokeLinejoin: 'round',
        strokeWidth: '1.1930027515339008px',
      }}
      />
      <path
      d="M296.36,386.45c9.07-3.63,26-6.08,45.34-6.08a184.43,184.43,0,0,1,32.84,2.69"
      style={{
        fill: 'none',
        stroke: '#fff',
        strokeLinecap: 'round',
        strokeLinejoin: 'round',
        strokeWidth: '1.1930027515339008px',
      }}
      />
      <path
      d="M330.94,396.74c-6.11-.85-10.2-2.4-10.2-4.18,0-2.69,9.39-4.87,21-4.87s20.95,2.18,20.95,4.87c0,2.31-6.9,4.24-16.16,4.74"
      style={{
        fill: 'none',
        stroke: '#fff',
        strokeLinecap: 'round',
        strokeLinejoin: 'round',
        strokeWidth: '1.1930027515339008px',
      }}
      />
    </g>
    <g id="freepik--Landscape--inject-21">
      <path
      d="M51.52,299.68c31.49-8.95,97.75-26.61,134.32-27.94C235,270,318,305.68,369.82,311.93s86.64,4.47,86.64,4.47"
      style={{
        fill: 'none',
        stroke: '#263238',
        strokeLinecap: 'round',
        strokeLinejoin: 'round',
        strokeWidth: '1.1930027515339008px',
      }}
      />
      <path
      d="M34,304.79s2.72-.83,7.49-2.22"
      style={{
        fill: 'none',
        stroke: '#263238',
        strokeLinecap: 'round',
        strokeLinejoin: 'round',
        strokeWidth: '1.1930027515339008px',
      }}
      />
      <path
      d="M442.47,249.12a228.34,228.34,0,0,0-55.3-5.23c-38.42,1.29-80,6.37-131.41,13s-124.62-30-174.4-16.41-46,17.68-46,17.68"
      style={{
        fill: 'none',
        stroke: '#263238',
        strokeLinecap: 'round',
        strokeLinejoin: 'round',
        strokeWidth: '1.1930027515339008px',
      }}
      />
      <path
      d="M456.63,252.8s-1.94-.64-5.45-1.57"
      style={{
        fill: 'none',
        stroke: '#263238',
        strokeLinecap: 'round',
        strokeLinejoin: 'round',
        strokeWidth: '1.1930027515339008px',
      }}
      />
    </g>
    <g id="freepik--Clouds--inject-21">
      <path
      d="M364.45,158.35a10.35,10.35,0,0,0-20.1,0Z"
      style={{
        fill: 'none',
        stroke: '#263238',
        strokeLinecap: 'round',
        strokeLinejoin: 'round',
        strokeWidth: '1.1930027515339008px',
      }}
      />
      <path
      d="M466,158.35a12.81,12.81,0,0,0-11-9.77A30,30,0,0,0,425.42,113a30.08,30.08,0,0,0-29.61,24.79,19.22,19.22,0,0,0-31.06,15.16,19.41,19.41,0,0,0,.79,5.42Z"
      style={{
        fill: 'none',
        stroke: '#263238',
        strokeLinecap: 'round',
        strokeLinejoin: 'round',
        strokeWidth: '1.1930027515339008px',
      }}
      />
      <path
      d="M185.57,182.49a5.25,5.25,0,0,0-10.21,0Z"
      style={{
        fill: 'none',
        stroke: '#263238',
        strokeLinecap: 'round',
        strokeLinejoin: 'round',
        strokeWidth: '1.1930027515339008px',
      }}
      />
      <path
      d="M237.12,182.49a6.52,6.52,0,0,0-5.59-5,15.27,15.27,0,1,0-30-5.48,9.76,9.76,0,0,0-15.77,7.69,10.06,10.06,0,0,0,.4,2.76Z"
      style={{
        fill: 'none',
        stroke: '#263238',
        strokeLinecap: 'round',
        strokeLinejoin: 'round',
        strokeWidth: '1.1930027515339008px',
      }}
      />
      <path
      d="M231.93,198.63a3.31,3.31,0,0,0-6.44,0Z"
      style={{
        fill: 'none',
        stroke: '#263238',
        strokeLinecap: 'round',
        strokeLinejoin: 'round',
        strokeWidth: '1.1930027515339008px',
      }}
      />
      <path
      d="M264.47,198.63a4.1,4.1,0,0,0-3.53-3.13,9.48,9.48,0,0,0,.16-1.77A9.64,9.64,0,0,0,242,192a6.16,6.16,0,0,0-9.95,4.86,6.25,6.25,0,0,0,.25,1.74Z"
      style={{
        fill: 'none',
        stroke: '#263238',
        strokeLinecap: 'round',
        strokeLinejoin: 'round',
        strokeWidth: '1.1930027515339008px',
      }}
      />
    </g>
    <g id="freepik--Character--inject-21">
      <path d="M162.65,313.83a1.89,1.89,0,0,1-1-.27,2,2,0,0,1-.7-2.67c.49-.86,124.13-135.69,180.7-185.13a1,1,0,0,1,1.36.1,1,1,0,0,1-.1,1.38C286.62,176.47,164.81,312,164.32,312.85A1.92,1.92,0,0,1,162.65,313.83Z" style={{ fill: '#263238' }} />
      <path d="M169.48,287s6.13-6.54,9.81-6.54,10.63,6.13,10.22,9.4-6.54.41-6.54.41-5.73,7.77-11.45,6.54S169.48,287,169.48,287Z" style={{ fill: '#ECEFF1', stroke: '#263238', strokeLinecap: 'round', strokeLinejoin: 'round', strokeWidth: '1.1930027515339008px' }} />
      <path d="M183,290.25s3.75,2.6,4.08,4.43-4.16,7-9.15,8.16-7.66-1.67-6.16-4.33S179.22,290.49,183,290.25Z" style={{ fill: '#ECEFF1', stroke: '#263238', strokeLinecap: 'round', strokeLinejoin: 'round', strokeWidth: '1.1930027515339008px' }} />
      <path d="M337,266.56V131.27s-2.73,9.79-2.73,10.5" style={{ fill: 'none', stroke: '#263238', strokeLinecap: 'round', strokeLinejoin: 'round', strokeWidth: '1.1930027515339008px' }} />
      <rect x="289.68" y="273.69" width="103.74" height="83.12" style={{ fill: '#ECEFF1', stroke: '#263238', strokeLinecap: 'round', strokeLinejoin: 'round', strokeWidth: '1.1930027515339008px' }} />
      <path d="M338.48,273.34v-4.76a1.19,1.19,0,0,0-2.38,0v4.76Z" style={{ fill: '#263238' }} />
      <path d="M348,261.76l0,.24a1.15,1.15,0,0,0-1-.61,1.2,1.2,0,0,0-1.2,1.2V275.3a3.67,3.67,0,0,1-3.66,3.67,3.57,3.57,0,0,1-1.46-.31,2,2,0,0,0,.3,2.58,6.34,6.34,0,0,0,1.16.11,6.05,6.05,0,0,0,6.05-6.05v-5.89h2.74Z" style={{ fill: '#263238' }} />
      <path d="M337.1,130s2.12-7.53.24-6.83S337.1,130,337.1,130Z" style={{ fill: 'none', stroke: '#263238', strokeLinecap: 'round', strokeLinejoin: 'round', strokeWidth: '1.1930027515339008px' }} />
      <path d="M337.1,130s-8-2.83-7.29-.24S337.1,130,337.1,130Z" style={{ fill: 'none', stroke: '#263238', strokeLinecap: 'round', strokeLinejoin: 'round', strokeWidth: '1.1930027515339008px' }} />
      <path d="M164.59,195.63s-9.87-5.53-29.23-2.76-23.05,18.73-19.89,35.32,21.47,30.64,24.24,29.46-.79-38.32,5.53-45.43,26.86-5.92,28-11.45S164.59,195.63,164.59,195.63Z" style={{ fill: '#263238', stroke: '#263238', strokeLinecap: 'round', strokeLinejoin: 'round', strokeWidth: '1.1930027515339008px' }} />
      <path d="M130.18,205.48l2,13.07s-12.4,33.85-10.39,38.55,20.77,6.36,20.77,6.36,30.5,3.69,39.55,0,4.36-14.41,3.35-17.42-6.7-27.15-6.7-27.15,2-5.7,2-8.71-.34-11.4-1.68-13.41-24.8-4.36-35.19-2.68S128.84,198.45,130.18,205.48Z" style={{ fill: '#757575', stroke: '#263238', strokeLinecap: 'round', strokeLinejoin: 'round', strokeWidth: '1.1930027515339008px' }} />
      <path d="M135.55,220.57s-.34,29.15,1.34,34.85,8.38,12.4,22.45,10.72,15.42-15.08,15.42-15.08l-1-31.16Z" style={{ fill: '#fff', stroke: '#263238', strokeLinecap: 'round', strokeLinejoin: 'round', strokeWidth: '1.1930027515339008px' }} />
      <path d="M159.68,241.51a2.52,2.52,0,1,1-2.52-2.51A2.51,2.51,0,0,1,159.68,241.51Z" style={{ fill: 'none', stroke: '#263238', strokeMiterlimit: 10, strokeWidth: '1.1930027515339008px' }} />
      <path d="M159.34,252.07a1.68,1.68,0,1,1-1.67-1.68A1.67,1.67,0,0,1,159.34,252.07Z" style={{ fill: '#263238' }} />
      <path d="M149.22,230.76c1.07,1.16,1.44,2.55.84,3.12s-2,.09-3.05-1.06-1.45-2.54-.84-3.11S148.15,229.61,149.22,230.76Z" style={{ fill: '#263238' }} />
      <path d="M162.83,230.76c-1.07,1.16-1.45,2.55-.84,3.12s2,.09,3-1.06,1.45-2.54,.84-3.11S163.9,229.61,162.83,230.76Z" style={{ fill: '#263238' }} />
      <path d="M142.06,226.81a6.4,6.4,0,0,1,7-2.58" style={{ fill: 'none', stroke: '#263238', strokeLinecap: 'round', strokeLinejoin: 'round', strokeWidth: '1.1930027515339008px' }} />
      <path d="M162.3,224.6s4.78-1.47,6.26,2.58" style={{ fill: 'none', stroke: '#263238', strokeLinecap: 'round', strokeLinejoin: 'round', strokeWidth: '1.1930027515339008px' }} />
      <path d="M178.44,411.62s5.27-3.16,8.19-4.4a8,8,0,0,1,.84-.33c2.58-.86,9.89-.43,16.76-4.73s3.44-9.46-1.72-10.75-10.74-3-10.74-3l-1.29-20.21s-15.48,4.3-20.64,6.45-2.15,32.67-1.72,35.25S168.55,414.2,178.44,411.62Z" style={{ fill: '#263238', stroke: '#263238', strokeLinecap: 'round', strokeLinejoin: 'round', strokeWidth: '1.1930027515339008px' }} />
      <path d="M195.64,402.16c-9,1.72-9,3.44-18.92,5.16a38.38,38.38,0,0,1-8.83.72c.1.92.18,1.57.23,1.86.43,2.58,.43,4.3,10.32,1.72,0,0,5.27-3.16,8.19-4.4a8,8,0,0,1,.84-.33c2.58-.86,9.89-.43,16.76-4.73,2.21-1.37,3.34-2.84,3.71-4.24A51.56,51.56,0,0,1,195.64,402.16Z" style={{ fill: '#fff', stroke: '#263238', strokeLinecap: 'round', strokeLinejoin: 'round', strokeWidth: '1.1930027515339008px' }} />
      <path d="M199.22,391.15s-.33,23.46-1,28.48.33,11.4,8,11.4,22.79-5,28.15-6,14.08-3.36,17.76-11.73-18.76-7.38-18.76-7.38l1.34-17.09S211.62,393.49,199.22,391.15Z" style={{ fill: '#263238', stroke: '#263238', strokeLinecap: 'round', strokeLinejoin: 'round', strokeWidth: '1.1930027515339008px' }} />
      <path d="M252.17,413.27a3.74,3.74,0,0,0,.28-2.63,21,21,0,0,1-9,7c-8,3.35-23.13,7-34.52,8.72-5.21.76-8.51-.09-10.58-1.23.74,3.25,2.91,5.92,7.9,5.92,7.71,0,22.79-5,28.15-6S248.49,421.64,252.17,413.27Z" style={{ fill: '#fff', stroke: '#263238', strokeLinecap: 'round', strokeLinejoin: 'round', strokeWidth: '1.1930027515339008px' }} />
      <path d="M233.41,405.89s1.67,5.7-3,9.39" style={{ fill: 'none', stroke: '#fff', strokeLinecap: 'round', strokeLinejoin: 'round', strokeWidth: '1.1930027515339008px' }} />
      <path d="M196.88,378.75s-.52,10.19.05,12.23c2.14,7.74,2.82,5.93,18.91,5.59s22.59-6.76,24.27-10.78,0-12.74-.67-15.76-6-4-8.05-3.68S197.88,375.4,196.88,378.75Z" style={{ fill: '#757575', stroke: '#263238', strokeLinecap: 'round', strokeLinejoin: 'round', strokeWidth: '1.1930027515339008px' }} />
      <path d="M86.28,404.22v22.52A4.84,4.84,0,0,0,88.9,431l36.2,18.69a4.81,4.81,0,0,0,4.19.12l53.33-20.33a4.84,4.84,0,0,0,2.86-4.41V397.85l-61,18.43Z" style={{ fill: '#ECEFF1' }} />
        <g style={{ clipPath: 'url(#freepik--clip-path--inject-21)' }}>
        <path d="M127.17,415.47l-2.68.81L86.28,404.22v22.52A4.84,4.84,0,0,0,88.9,431l36.2,18.69a4.76,4.76,0,0,0,2.07.54Z" style={{ opacity: '0.18' }} />
        </g>
        <path d="M86.28,404.22v22.52A4.84,4.84,0,0,0,88.9,431l36.2,18.69a4.81,4.81,0,0,0,4.19.12l53.33-20.33a4.84,4.84,0,0,0,2.86-4.41V397.85l-61,18.43Z" style={{ fill: 'none', stroke: '#263238', strokeLinecap: 'round', strokeLinejoin: 'round', strokeWidth: '1.1930027515339008px' }} />
        <path d="M142,366.2,83.5,385a2.26,2.26,0,0,0-1.57,2.16v16.68a2.27,2.27,0,0,0,1.29,2L124,425.25a2.27,2.27,0,0,0,1.77.08L187,402.42a2.27,2.27,0,0,0,1.48-2.12l.11-15.65a2.29,2.29,0,0,0-1.79-2.22l-43.64-16.29A2.36,2.36,0,0,0,142,366.2Z" style={{ fill: '#fff' }} />
        <g style={{ clipPath: 'url(#freepik--clip-path-2--inject-21)' }}>
        <path d="M123.93,425.24h0a2.27,2.27,0,0,0,1.77.08L187,402.42a2.27,2.27,0,0,0,1.48-2.12l.11-15.65a2.2,2.2,0,0,0-.54-1.45l-63.25,23.36Z" style={{ fill: '#ECEFF1' }} />
        <path d="M123.93,425.24h0a2.27,2.27,0,0,0,1.77.08L187,402.42a2.27,2.27,0,0,0,1.48-2.12l.11-15.65a2.2,2.2,0,0,0-.54-1.45l-63.25,23.36Z" style={{ fill: '#fff', opacity: '0.5' }} />
        <path d="M81.93,387.11v16.68a2.27,2.27,0,0,0,1.29,2L124,425.25a2.24,2.24,0,0,0,.87.22V406.56L82,386.72A1.67,1.67,0,0,0,81.93,387.11Z" style={{ fill: '#ECEFF1' }} />
        </g>
        <path d="M142,366.2,83.5,385a2.26,2.26,0,0,0-1.57,2.16v16.68a2.27,2.27,0,0,0,1.29,2L124,425.25a2.27,2.27,0,0,0,1.77.08L187,402.42a2.27,2.27,0,0,0,1.48-2.12l.11-15.65a2.29,2.29,0,0,0-1.79-2.22l-43.64-16.29A2.36,2.36,0,0,0,142,366.2Z" style={{ fill: 'none', stroke: '#263238', strokeLinecap: 'round', strokeLinejoin: 'round', strokeWidth: '1.1930027515339008px' }} />
        <path d="M222.35,335.52s7.7,3.68,11.73,11.06,1,21.44-1.35,25.8-18.09,6.37-23.45,6.37-6.37-.67-6.37-.67-17.09,3.35-27.82,5.36-8-23.12-4.69-34.52,22.12-17.09,29.83-17.09S222.35,335.52,222.35,335.52Z" style={{ fill: '#263238', stroke: '#263238', strokeLinecap: 'round', strokeLinejoin: 'round', strokeWidth: '1.1930027515339008px' }} />
        <path d="M202.91,378.08s14.41-5,20.44-17.76" style={{ fill: 'none', stroke: '#fff', strokeLinecap: 'round', strokeLinejoin: 'round', strokeWidth: '1.1930027515339008px' }} />
        <path d="M216.65,370.7a38.27,38.27,0,0,0,12.4-8.37" style={{ fill: 'none', stroke: '#fff', strokeLinecap: 'round', strokeLinejoin: 'round', strokeWidth: '1.1930027515339008px' }} />
        <path d="M182.8,346.58s4,21.11,2,29.82-13.74,10.06-16.42,9.05-1.34-21.78-1.34-32.17S177.44,343.56,182.80,346.58Z" style={{ fill: '#757575', stroke: '#263238', strokeLinecap: 'round', strokeLinejoin: 'round', strokeWidth: '1.1930027515339008px' }} />
        <path d="M97.34,290.27S95,304,96.67,310.72a28.62,28.62,0,0,0,4.69,10.39s-8.38,12.4-6.7,22.78,6,11.73,6,11.73-3.68,19.11,3,25.81,21.45,14.07,37.87,11.06,27.48-3.69,30.83-9.39,1.34-30.83,1.34-30.83-.67-27.81-1.34-44.91-3-30.83-11.06-37.53-43.57,3.69-54.29,10.72S97.34,290.27,97.34,290.27Z" style={{ fill: '#ECEFF1' }} />
        <g style={{ clipPath: 'url(#freepik--clip-path-3--inject-21)' }}>
        <path d="M99.73,290.27s-2.35,13.74-.67,20.45a28.43,28.43,0,0,0,4.69,10.39s-8.38,12.4-6.7,22.78,6,11.73,6,11.73-3.69,19.11,3,25.81S127.54,395.5,144,392.49s27.49-3.69,30.84-9.39,1.34-30.83,1.34-30.83-.67-27.81-1.34-44.91-3-30.83-11.06-37.53-43.57,3.69-54.29,10.72S99.73,290.27,99.73,290.27Z" style={{ opacity: '0.30000000000000004' }} />
        </g>
        <path d="M97.34,290.27S95,304,96.67,310.72a28.62,28.62,0,0,0,4.69,10.39s-8.38,12.4-6.7,22.78,6,11.73,6,11.73-3.68,19.11,3,25.81,21.45,14.07,37.87,11.06,27.48-3.69,30.83-9.39,1.34-30.83,1.34-30.83-.67-27.81-1.34-44.91-3-30.83-11.06-37.53-43.57,3.69-54.29,10.72S97.34,290.27,97.34,290.27Z" style={{ fill: 'none', stroke: '#263238', strokeLinecap: 'round', strokeLinejoin: 'round', strokeWidth: '1.1930027515339008px' }} />
        <path d="M101.36,321.11a40.77,40.77,0,0,0,35.86,5" style={{ fill: 'none', stroke: '#263238', strokeLinecap: 'round', strokeLinejoin: 'round', strokeWidth: '1.1930027515339008px' }} />
        <path d="M100.69,355.62s17.09,16.76,45.25.67" style={{ fill: 'none', stroke: '#263238', strokeLinecap: 'round', strokeLinejoin: 'round', strokeWidth: '1.1930027515339008px' }} />
        <path d="M167.38,273.85s-6.36-9.72-15.08-15.08-31.16-9.38-40.21-11.06-18.77-1-21.45,9-2.35,26.81.33,34.18,13.74,11.73,22.46,6.71,32.84-24.47,41.22-25.47S166.71,277.54,167.38,273.85Z" style={{ fill: '#757575' }} />
        <g style={{ clipPath: 'url(#freepik--clip-path-4--inject-21)' }}>
        <path d="M148.79,272c5.11-2.13-7.67,1.7-8.52.42s8.94-7.66,11.07-8.51-12.35,2.13-11.92,0,14.05-2.56,4.68-4.69-40-7.67-46-9.8a4.94,4.94,0,0,1-1.29-.64,11.92,11.92,0,0,0-6.17,8c-2.68,10.05-2.35,26.81.33,34.18,2.34,6.42,11,10.55,19,8.20,3.69-3,7.1-6.94,12.87-10.57C134.31,281.33,143.68,274.09,148.79,272Z" style={{ opacity: '0.30000000000000004' }} />
        </g>
        <path d="M167.38,273.85s-6.36-9.72-15.08-15.08-31.16-9.38-40.21-11.06-18.77-1-21.45,9-2.35,26.81.33,34.18,13.74,11.73,22.46,6.71,32.84-24.47,41.22-25.47S166.71,277.54,167.38,273.85Z" style={{ fill: 'none', stroke: '#263238', strokeLinecap: 'round', strokeLinejoin: 'round', strokeWidth: '1.1930027515339008px' }} />
        <path d="M203.58,319.43s7.71,1,12.73,3,8.38,14.41,6.37,16.08-6-.33-6-.33a49.07,49.07,0,0,1-9.72,2.34C202.91,340.88,198.55,321.78,203.58,319.43Z" style={{ fill: '#ECEFF1', stroke: '#263238', strokeLinecap: 'round', strokeLinejoin: 'round', strokeWidth: '1.1930027515339008px' }} />
        <path d="M178.11,318.42s1.34,0,8.71-3.35,13.41-3.35,18.10,4,6.70,16.43,4,21.79-12.73,9.05-18.10,9.05-6-7-6-7-.67-11.06-4-15.08S176.77,319.43,178.11,318.42Z" style={{ fill: '#757575', stroke: '#263238', strokeLinecap: 'round', strokeLinejoin: 'round', strokeWidth: '1.1930027515339008px' }} />
        <path d="M153.31,273.85c7.37-2.68,16.76-1,20.11,8.38s6.36,36.86,6.36,36.86,8.38,1,11.73,4.70,5,13.07,4.36,17.76-12.40,13.40-25.80,13.74-23.13-6-27.82-23.13S139.42,289,139.42,289s1.70-7.67,4.26-9.38" style={{ fill: '#ECEFF1' }} />
        <g style={{ clipPath: 'url(#freepik--clip-path-5--inject-21)' }}>
        <path d="M195.87,341.55c.67-4.69-1-14.08-4.36-17.76-.13-.15-.29-.29-.43-.43a85.25,85.25,0,0,1,.72,9.08c.67,19.67-26.82,16.38-32.36,2.13-3-7.67-3.84-41.32-12.78-43.87-5.16-1.47-6.92,2.57-7.48,6.26-.18,9.65.14,24.52,3.07,35.20,4.69,17.10,14.41,23.46,27.82,23.13S195.20,346.24,195.87,341.55Z" style={{ opacity: '0.30000000000000004' }} />
        </g>
        <path d="M153.31,273.85c7.37-2.68,16.76-1,20.11,8.38s6.36,36.86,6.36,36.86,8.38,1,11.73,4.70,5,13.07,4.36,17.76-12.40,13.40-25.80,13.74-23.13-6-27.82-23.13S139.42,289,139.42,289s1.70-7.67,4.26-9.38" style={{ fill: 'none', stroke: '#263238', strokeLinecap: 'round', strokeLinejoin: 'round', strokeWidth: '1.1930027515339008px' }} />
        <path d="M179.78,319.09S182.40,331.30,168.94,338" style={{ fill: 'none', stroke: '#263238', strokeLinecap: 'round', strokeLinejoin: 'round', strokeWidth: '1.1930027515339008px' }} />
    </g>
    <g id="freepik--Text--inject-21">
      <path d="M113.1,106.25c0-2.78,1.28-4.83,4.17-4.83s4.23,2,4.23,4.83V116c0,2.78-1.29,4.83-4.23,4.83s-4.17-2-4.17-4.83Zm1.25,9.84c0,2.08.82,3.6,2.92,3.6s3-1.52,3-3.6v-9.92c0-2.07-.84-3.6-3-3.6s-2.92,1.53-2.92,3.6Z" style={{ fill: '#263238' }} />
      <path d="M123.49,106.25c0-2.78,1.28-4.83,4.17-4.83s4.23,2,4.23,4.83V116c0,2.78-1.28,4.83-4.23,4.83s-4.17-2-4.17-4.83Zm1.25,9.84c0,2.08.82,3.6,2.92,3.6s3-1.52,3-3.6v-9.92c0-2.07-.84-3.6-3-3.6s-2.92,1.53-2.92,3.6Z" style={{ fill: '#263238' }} />
      <path d="M137.92,101.59c2.94,0,4.09,1.85,4.09,4.63v2.08c0,3-1.4,4.52-4.42,4.52h-2.37v7.86H134V101.59Zm-.33,10.09c2.21,0,3.16-1,3.16-3.3v-2.24c0-2.07-.71-3.41-2.83-3.41h-2.7v9Z" style={{ fill: '#263238' }} />
      <path d="M151.93,106.2v.4h-1.2v-.49c0-2-.76-3.54-2.83-3.54s-2.84,1.5-2.84,3.52c0,4.63,6.9,4.71,6.9,10,0,2.75-1.2,4.77-4.12,4.77s-4.11-2-4.11-4.77v-1h1.2v1.06c0,2,.79,3.52,2.89,3.52s2.89-1.48,2.89-3.52c0-4.58-6.9-4.66-6.9-10,0-2.86,1.25-4.72,4.06-4.75S151.93,103.44,151.93,106.2Z" style={{ fill: '#263238' }} />
      <path d="M155.07,118.28v2.4h-1.22v-2.4Z" style={{ fill: '#263238' }} />
      <path d="M158.48,118.28v2.4h-1.22v-2.4Z" style={{ fill: '#263238' }} />
      <path d="M161.89,118.28v2.4h-1.23v-2.4Z" style={{ fill: '#263238' }} />
      <path d="M117.13,129.36c3,0,4.09,1.85,4.09,4.64v2.07c0,3-1.39,4.53-4.41,4.53h-2.38v7.85h-1.25V129.36Zm-.32,10.09c2.2,0,3.16-1,3.16-3.3v-2.24c0-2.07-.71-3.4-2.84-3.4h-2.7v8.94Z" style={{ fill: '#263238' }} />
      <path d="M124.58,144.22l-1,4.23h-1.15l4.17-19.12h1.83l4.25,19.12h-1.25l-1-4.23Zm.19-1.09h5.56l-2.81-12.35Z" style={{ fill: '#263238' }} />
      <path d="M142.77,134v1.42h-1.2v-1.5c0-2-.79-3.6-2.89-3.6s-2.89,1.56-2.89,3.6v9.93c0,2,.79,3.57,2.89,3.57s2.89-1.53,2.89-3.57v-4.12H139v-1.14h3.73v5.18c0,2.75-1.2,4.82-4.12,4.82s-4.11-2.07-4.11-4.82V134c0-2.75,1.2-4.82,4.11-4.82S142.77,131.27,142.77,134Z" style={{ fill: '#263238' }} />
      <path d="M151.34,138.2v1.14h-5.21v8h6.27v1.15h-7.53V129.36h7.53v1.15h-6.27v7.69Z" style={{ fill: '#263238' }} />
      <path d="M159.82,148.45h-1.15V129.36h1.64L166,145.48V129.36h1.14v19.09h-1.39l-6-17Z" style={{ fill: '#263238' }} />
      <path d="M169.26,134c0-2.78,1.28-4.82,4.17-4.82s4.23,2,4.23,4.82v9.77c0,2.78-1.29,4.82-4.23,4.82s-4.17-2-4.17-4.82Zm1.25,9.85c0,2.07.82,3.6,2.92,3.6s3-1.53,3-3.6v-9.93c0-2.07-.84-3.6-3-3.6s-2.92,1.53-2.92,3.6Z" style={{ fill: '#263238' }} />
      <path d="M183,148.45V130.51h-3.87v-1.15h9v1.15h-3.9v17.94Z" style={{ fill: '#263238' }} />
      <path d="M200.08,138.66v1.14h-4.94v8.65h-1.25V129.36h7.25v1.15h-6v8.15Z" style={{ fill: '#263238' }} />
      <path d="M203,134c0-2.78,1.28-4.82,4.17-4.82s4.23,2,4.23,4.82v9.77c0,2.78-1.28,4.82-4.23,4.82s-4.17-2-4.17-4.82Zm1.25,9.85c0,2.07.82,3.6,2.92,3.6s3-1.53,3-3.6v-9.93c0-2.07-.84-3.6-3-3.6s-2.92,1.53-2.92,3.6Z" style={{ fill: '#263238' }} />
      <path d="M214.64,143.84c0,2,.77,3.63,2.87,3.63s2.86-1.58,2.86-3.63V129.36h1.17v14.43c0,2.72-1.14,4.82-4.06,4.82s-4.09-2.1-4.09-4.82V129.36h1.25Z" style={{ fill: '#263238' }} />
      <path d="M224.84,148.45H223.7V129.36h1.63l5.73,16.12V129.36h1.15v19.09h-1.4l-6-17Z" style={{ fill: '#263238' }} />
      <path d="M238.56,129.36c2.95,0,4.23,1.94,4.23,4.75v9.59c0,2.81-1.28,4.75-4.23,4.75h-4.2V129.36Zm0,17.94c2.13,0,3-1.44,3-3.54v-9.71c0-2.1-.9-3.54-3-3.54h-2.91V147.3Z" style={{ fill: '#263238' }} />
      <path d="M302,325.13,315.61,293h8.15v32.13h3.53v6.79h-3.53v8.63h-7.34v-8.63H302Zm14.4,0V307.27l-7.54,17.86Z" style={{ fill: '#263238' }} />
      <path d="M330.08,304.41c0-7.6,4-12,11.34-12s11.34,4.35,11.34,12v24.72c0,7.61-4,12-11.34,12s-11.34-4.35-11.34-12Zm7.47,25.2c0,3.4,1.49,4.69,3.87,4.69s3.87-1.29,3.87-4.69V303.94c0-3.4-1.5-4.69-3.87-4.69s-3.87,1.29-3.87,4.69Z" style={{ fill: '#263238' }} />
      <path d="M355.82,325.13,369.4,293h8.15v32.13h3.53v6.79h-3.53v8.63h-7.34v-8.63H355.82Zm14.39,0V307.27l-7.53,17.86Z" style={{ fill: '#263238' }} />
    </g>
  </svg>
  )
}

export default Svg404Page;
